import FixedBottomActions from './FixedBottomActions.vue'

export default FixedBottomActions
